import styled from 'styled-components'
import { Link as LinkR, NavLink } from 'react-router-dom'

export const Nav = styled.nav`
    background:${({scrollNav}) => (scrollNav ? '#000' : '#003')};
    width:100%;
    height:122px;
    align-items:center;
    top:0;
    right:0;
    display:flex;
    z-index:10;
    font-size:1rem;
    box-shadow: 0 0 0.5rem #000;
    @media (max-width:768px){height:80px;}
`
export const NavbarContainer = styled.div`
    width:100%;
    height:100%;
    display:flex;
    justify-content:space-between;
    align-items:center;
    padding:1rem 5%;
`
export const NavLogo = styled(LinkR)`
    width:220px;
    justify-self:flex-start;
    display:flex;
    align-items:center;
    gap: 10px;
    cursor:pointer;
    padding: 10px;
    text-decoration: none;

    .brand-text {
        font-size: 24px;
        font-weight: 800;
        margin: 0;
        background: linear-gradient(90deg, #F54748 0%, #000033 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        letter-spacing: 1px;
    }

    @media (max-width:991px){
        .brand-text {
            font-size: 20px;
        }
    }
    &::before{
        content:'';
        position:absolute;
        width:250px;
        background:#fff;
        bottom:0;
        top:0;
        z-index:-1;
        transform:skew(30deg);
        @media (max-width:991px){width:220px}
    }
    &::after{
        content:'';
        position:absolute;
        width:230px;
        background:#fff;
        left:0;
        bottom:0;
        top:0;
        z-index:-1;
        @media (max-width:991px){width:200px}
    }
`
export const ImgLogo = styled.img`
    width: 60px;
    height: 60px;
    object-fit: contain;
    align-items:center;
`
export const MobileIcon = styled.div`
    display:none;

    @media (max-width:768px){
        display:block;
        color:#fff;
        font-size:2.4rem;
        text-align:right;
    }
`
export const NavMenu = styled.ul`
    margin:0;
    display:flex;
    list-style:none;
    justify-content:center;
    align-items:center;
    text-align:center;
    position:relative;

    @media (max-width:768px){display:none}    
`
export const DropdownMenu = styled.ul`
    width:200px;
    position:absolute;
    display:none;
    top:4.4rem;
    list-style:none;
    text-align:start;
    right:0;
    left:0;
    background:#F54748;
    padding:0;
    border-radius:.2rem;
`
export const NavLinks = styled(NavLink)`
    color:#fff;
    font-size:1.7rem;
    align-items:center;
    padding:2rem 1rem;
    margin-right:1.3rem;
    position:relative;
    font-weight:500;
    border-radius:.5rem;
    cursor:pointer;
    &:hover{color:#F54748; transition:0.2s;
        .dropdownMenu{display:block;top:6rem;transition:0.5s;}
    }
    &.active{
        background:#F54748;
        transition:0.5s;
        color:#fff;
        padding:2rem 1rem;
        .dropdownMenu{top:4.4rem; transition:0.5s;}
    }
`
export const DropdownLink = styled(LinkR)`
    display:block;
    font-size:1.5rem;
    width:100%;
    text-decoration:none;
    color:#fff;
    padding:1.6rem 2rem;
    border-radius:.5rem;
    border-bottom:.1rem solid #000;
    &:hover{background:#000;color:#fff}
`
export const NavBtn = styled.div`
    display:flex;
`
export const NavBtnLink = styled(LinkR)`
    width:100%;
    background:transparent;
    color:#fff;
    font-size:1.7rem;
    padding:.5rem 2rem;
    font-weight:600;
    border:.2rem solid #F54748;
    border-radius:5rem;
    cursor:pointer;
    &:hover{
        background:#F54748;color:#fff;
    }
`